<template>
  <div>
    <div class="login_bg register ResetPassword">
      <div class="aa bg_box">
        <img class="bg_bg" src="img/login_bg.svg" alt="" />
        <img class="bg_img" src="img/login_img.svg" alt="" />
      </div>
      <div class="login_box">
        <div class="login_text">
          <div class="container">
            <div class="nav">
              <div class="logo">
                <img src="img/logo.png" alt="" />
              </div>
              <button class="home_btn">NTHU</button>
            </div>
            <div class="login">
              <div class="title">
                <h1>Reset Password</h1>
              </div>
              <div class="mb-3 form_group">
                <label for="emailInput" class="form-label"><img src="img/login_email.svg" alt="" /></label>
                <input type="email" class="form-control" :class="{ 'is-invalid': errors.email }" id="emailInput"
                  v-model="formData.email" placeholder="Email" @blur="validateEmail" />
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email }}
                </div>
              </div>
              <div class="mb-3 form_group">
                <label for="newPasswordInput" class="form-label"><img src="img/login_password.svg" alt="" /></label>
                <input type="password" class="form-control" :class="{ 'is-invalid': errors.newPassword }"
                  id="newPasswordInput" v-model="formData.newPassword" placeholder="New Password"
                  @blur="validateNewPassword" />
                <p class="notes">
                  *At least 8 characters, with uppercase, lowercase, and a
                  number.
                </p>
                <div class="invalid-feedback" v-if="errors.newPassword">
                  {{ errors.newPassword }}
                </div>
              </div>
              <div class="mb-3 form_group">
                <label for="confirmPasswordInput" class="form-label"><img src="img/login_password.svg" alt="" /></label>
                <input type="password" class="form-control" :class="{ 'is-invalid': errors.confirmPassword }"
                  id="confirmPasswordInput" v-model="formData.confirmPassword" placeholder="Confirm Password"
                  @blur="validateConfirmPassword" />
                <div class="invalid-feedback" v-if="errors.confirmPassword">
                  {{ errors.confirmPassword }}
                </div>
              </div>
              <hr class="line">
              <button class="login_btn" @click="handleResetPassword" :disabled="isSubmitting">
                {{ isSubmitting ? 'Resetting...' : 'Reset Password' }}
              </button>
              <div class="btn_box">
                <button @click="gotoLogin" class="register_btn">
                  Back to Login
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.098" height="12.098" viewBox="0 0 12.098 12.098">
                    <g id="arrow" transform="translate(1.158 1.414)">
                      <line id="_1" data-name="1" x2="9.526" transform="translate(0 0)" fill="none" stroke="#4d167d"
                        stroke-linecap="round" stroke-width="2" />
                      <line id="_2" data-name="2" x2="9.526" transform="translate(9.525 0) rotate(90)" fill="none"
                        stroke="#4d167d" stroke-linecap="round" stroke-width="2" />
                      <line id="_3" data-name="3" x2="13.109" transform="translate(0.256 9.269) rotate(-45)" fill="none"
                        stroke="#4d167d" stroke-linecap="round" stroke-width="2" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="footer_box">
          <div class="container">
            <div class="box">
              <ul class="list">
                <li v-for="(item, index) in listItems" :key="index">
                  <img :src="item.src" />
                  <p>{{ item.text }}</p>
                </li>
              </ul>
              <div class="social_list">
                <a v-for="(item, index) in socialItems" :key="index" :href="item.to" :title="item.title + '(另開新視窗)'"
                  target="_blank">
                  <img :src="item.src" :alt="item.title" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';
import Swal from 'sweetalert2';

export default {
  name: "ResetPassword",
  props: ['resetCode'],
  data() {
    return {
      formData: {
        email: '',
        newPassword: '',
        confirmPassword: '',
        resetPasswordCode: this.$route.params.resetCode || '',
      },
      errors: {
        email: '',
        newPassword: '',
        confirmPassword: '',
      },
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      listItems: [
        {
          src: require("/public/img/icon_email_p.svg"),
          text: "itc@my.nthu.edu.tw",
        },
        {
          src: require("/public/img/icon_phone_p.svg"),
          text: "+886-3-5162453",
        },
        {
          src: require("/public/img/icon_address_p.svg"),
          text: "Office of Global Affairs, National Tsing Hua University No. 101, Section 2, Kuang-Fu Road, Hsinchu, Taiwan 30013",
        },
      ],
      socialItems: [
        {
          to: "https://zh-tw.facebook.com/people/Global-Affairs-National-Tsing-Hua-University-%E5%9B%9B%E6%B5%B7%E5%90%8C%E6%96%B9/100057749195868/#",
          title: "fb",
          src: require("/public/img/icon_fb_p.svg"),
        },
        {
          to: "https://www.instagram.com/nthuoga/",
          title: "ig",
          src: require("/public/img/icon_ig_p.svg"),
        },
        {
          to: "https://www.youtube.com/channel/UCjaf371JsfFmBZ6e1vMl1Nw",
          title: "youtube",
          src: require("/public/img/icon_youtube_p.svg"),
        },
        {
          to: "https://www.threads.net/@nthuoga?xmt=AQGz5FeYM3l3MXlc41vArPNDdktfeqREq2lRYHQV44k9EqE",
          title: "threads",
          src: require("/public/img/icon_threads_p.svg"),
        },
      ],
    };
  },
  mounted() {
    // Check if reset code is provided
    if (!this.formData.resetPasswordCode) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Reset Link',
        text: 'Invalid reset link. Please request a new password reset.',
        confirmButtonColor: '#4d167d',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    }
  },
  methods: {
    ...mapActions(['resetPassword']),
    validateEmail() {
      if (!this.formData.email) {
        this.errors.email = 'Email is required';
        return false;
      }
      if (!validate.reg_email(this.formData.email)) {
        this.errors.email = 'Please enter a valid email address';
        return false;
      }
      this.errors.email = '';
      return true;
    },
    validateNewPassword() {
      if (!this.formData.newPassword) {
        this.errors.newPassword = 'New password is required';
        return false;
      }
      if (!validate.reg_password(this.formData.newPassword)) {
        this.errors.newPassword = 'Password must be at least 8 characters with uppercase, lowercase, and a number';
        return false;
      }
      this.errors.newPassword = '';
      return true;
    },
    validateConfirmPassword() {
      if (!this.formData.confirmPassword) {
        this.errors.confirmPassword = 'Please confirm your password';
        return false;
      }
      if (this.formData.newPassword !== this.formData.confirmPassword) {
        this.errors.confirmPassword = 'Passwords do not match';
        return false;
      }
      this.errors.confirmPassword = '';
      return true;
    },
    validateForm() {
      const isEmailValid = this.validateEmail();
      const isNewPasswordValid = this.validateNewPassword();
      const isConfirmPasswordValid = this.validateConfirmPassword();
      return isEmailValid && isNewPasswordValid && isConfirmPasswordValid;
    },
    async handleResetPassword() {
      // Clear previous messages
      this.successMessage = '';
      this.errorMessage = '';
      
      // Check reset code
      if (!this.formData.resetPasswordCode) {
        await Swal.fire({
          icon: 'error',
          title: 'Invalid Reset Link',
          text: 'Invalid reset link. Please request a new password reset.',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }
      
      // Validate form
      if (!this.validateForm()) {
        await Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please fix the errors before submitting',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        const result = await this.resetPassword({
          Account: this.formData.email,
          NewPassword: this.formData.newPassword,
          ConfirmPassword: this.formData.confirmPassword,
          ResetPasswordCode: this.formData.resetPasswordCode,
        });
        
        // 根據 result.data.ok 判斷成功或失敗
        if (result.success && result.data?.ok === true) {
          Swal.fire({
            icon: 'success',
            title: 'Password Reset Successful!',
            text: result.message || 'Your password has been successfully reset. You can now login with your new password.',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didClose: () => {
              // Clear form
              this.formData = {
                email: '',
                newPassword: '',
                confirmPassword: '',
                resetPasswordCode: '',
              };
              
              // Redirect to login after dialog closes
              this.$router.push('/');
            }
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Password Reset Failed',
            text: result.message || 'Failed to reset password. Please try again or request a new reset link.',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Unexpected Error',
          text: 'An unexpected error occurred. Please try again.',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        console.error('Reset password error:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    gotoLogin() {
      this.$router.push('/');
    },
  },
};
</script>
